"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultsSectionThumbnails = exports.ThumbnailSize = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_jss_1 = require("react-jss");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var SearchIconButton_1 = require("./SearchIconButton");
var ThumbnailSize;
(function (ThumbnailSize) {
    ThumbnailSize["small"] = "small";
    ThumbnailSize["medium"] = "medium";
    ThumbnailSize["large"] = "large";
})(ThumbnailSize || (exports.ThumbnailSize = ThumbnailSize = {}));
var useSearchResultsSectionThumbnailsStyles = (0, react_jss_1.createUseStyles)({
    thumbnailWrapper: {
        display: "flex",
    },
});
var onIconClick = function (size, callback) {
    if (typeof callback === "function") {
        callback(size);
    }
};
var SearchResultsSectionThumbnails = function (props) {
    var onThumbnailSizeChange = props.onThumbnailSizeChange, selectedSize = props.selectedSize;
    var _a = __read((0, Ioc_1.useContexts)(Contexts_1.IThemeContext), 1), theme = _a[0];
    var classes = useSearchResultsSectionThumbnailsStyles();
    var iconSize = 22;
    var selectedColor = "primary";
    var unselectedColor = theme.colors.baseContrast040;
    return ((0, jsx_runtime_1.jsxs)("div", { className: classes.thumbnailWrapper, children: [(0, jsx_runtime_1.jsx)(SearchIconButton_1.SearchIconButton, { iconName: "gridLarge", iconSize: iconSize, onClick: function () { return onIconClick(ThumbnailSize.large, onThumbnailSizeChange); }, fill: selectedSize === ThumbnailSize.large ? selectedColor : unselectedColor }), (0, jsx_runtime_1.jsx)(SearchIconButton_1.SearchIconButton, { iconName: "gridMedium", iconSize: iconSize, onClick: function () { return onIconClick(ThumbnailSize.medium, onThumbnailSizeChange); }, fill: selectedSize === ThumbnailSize.medium ? selectedColor : unselectedColor }), (0, jsx_runtime_1.jsx)(SearchIconButton_1.SearchIconButton, { iconName: "gridSmall", iconSize: iconSize, onClick: function () { return onIconClick(ThumbnailSize.small, onThumbnailSizeChange); }, fill: selectedSize === ThumbnailSize.small ? selectedColor : unselectedColor })] }));
};
exports.SearchResultsSectionThumbnails = SearchResultsSectionThumbnails;
//# sourceMappingURL=SearchResultsSectionThumbnails.js.map